import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    private readonly LOCAL_STORAGE_PREFIX_V1 = 'ngStorage-';

    private localStorageObject: Storage = window.localStorage;

    constructor(@Inject(PLATFORM_ID) private platformId: any) {}

    getItem(key: string): string | null {
        let str: string | null = this.localStorage.getItem(key) ?? null;

        if (!str) {
            str = this.localStorage.getItem(`${this.LOCAL_STORAGE_PREFIX_V1}${key}`) ?? null;
        }

        return str?.replace(/^"(.*)"$/, '$1') ?? null;
    }

    setItem(key: string, value: any, withV1Compatibility = false): void {
        let stringValue: string;

        if (typeof value !== 'string') {
            stringValue = JSON.stringify(value);
        } else {
            stringValue = `"${value}"`;
        }

        const finalKey = withV1Compatibility ? `${this.LOCAL_STORAGE_PREFIX_V1}${key}` : key;
        this.localStorage.setItem(finalKey, stringValue);
    }

    clear(): void {
        this.localStorage.clear();
    }

    key(index: number): string | null {
        return this.localStorage.key(index);
    }

    removeItem(key: string): void {
        this.localStorage.removeItem(key);
        this.localStorage.removeItem(`${this.LOCAL_STORAGE_PREFIX_V1}${key}`);
    }

    private get localStorage(): Storage {
        if (isPlatformBrowser(this.platformId) && this.localStorageObject) {
            return localStorage;
        } else {
            throw new Error('localStorage error!');
        }
    }
}
